import { HttpError, useCreate } from '@refinedev/core';

type UseForceBotJoinResult = {
  forceBotJoin: () => Promise<void>;
  isLoading: boolean;
  error: HttpError | null;
};

export const useForceBotJoin = (eventId: string): UseForceBotJoinResult => {
  const { mutateAsync, error, isLoading } = useCreate({
    resource: `calendar-events/${eventId}/force-bot-join`,
  });

  const forceBotJoin = async () => {
    await mutateAsync({
      values: {},
    });
  };

  return {
    forceBotJoin,
    isLoading,
    error,
  };
};
